// @flow
import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CommonPage from 'app/common/templates/CommonPage';
import StudentsSelector from 'app/components/StudentsSelector';
import Identifiers, { type ReassignTarget } from 'app/components/Identifiers';
import { useStudent } from 'app/dataProviders/student/hooks';

import selectStudentsAsReassignTargets from './selectStudentsAsReassignTargets';


type Props = {
  params: {
    id: ?string,
  },
  router: {
    replace: (path: string) => void,
  },
}

const IdentifiersPage = ({ params: { id }, router }: Props) => {
  const currentStudentId = useSelector(state => state.settings.current.id, shallowEqual);
  const student = useStudent(String(currentStudentId))

  // const timezone = useSelector(state => selectStudentTimezone(state, { id: currentStudentId }));
  const timezone = useSelector(state => state.user.timezone, shallowEqual);
  const { t } = useTranslation('identifiers-next');

  useEffect(() => {
    if ((!id || id === '0') && currentStudentId) {
      router.replace(`/identifiers/${currentStudentId}`);
    }
  }, [id, currentStudentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const reassignTargets: Array<ReassignTarget> = useSelector(selectStudentsAsReassignTargets);
  const {
    enable_reassign_identifiers_by_parents: reassignEnabled,
  } = useSelector(state => state.dealer, shallowEqual);

  return (
    <CommonPage header={t('page_title', 'Идентификаторы')}>
      <StudentsSelector />

      {currentStudentId
        && student
        && <Identifiers
          studentPerson={student.person}
          studentAccountID={student.accountID}
          reassignEnabled={reassignEnabled}
          reassignTargets={reassignTargets}
          timezone={timezone}
        />}
    </CommonPage>
  );
};

export default IdentifiersPage;
